import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import '../styles/Legal.css';

const Privacy = () => {
  return (
    <div className="legal-page" data-testid="privacy-page">
      <Navbar />
      
      <section className="legal-hero">
        <div className="container">
          <h1 className="page-title" data-testid="privacy-title">Privacy Policy</h1>
          <p className="page-subtitle" data-testid="privacy-subtitle">
            Last updated: January 2025
          </p>
        </div>
      </section>

      <section className="legal-content">
        <div className="container">
          <div className="legal-container">
            <div className="legal-section">
              <h2>Introduction</h2>
              <p>
                At BigSoftTech, we take your privacy seriously. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website or use our services.
              </p>
            </div>

            <div className="legal-section">
              <h2>Information We Collect</h2>
              <p>We collect information that you provide directly to us, including:</p>
              <ul>
                <li>Name and contact information (email, phone number)</li>
                <li>Company name and business information</li>
                <li>Project details and requirements</li>
                <li>Communications with our team</li>
                <li>Newsletter subscription preferences</li>
              </ul>
            </div>

            <div className="legal-section">
              <h2>How We Use Your Information</h2>
              <p>We use the information we collect to:</p>
              <ul>
                <li>Provide and improve our services</li>
                <li>Respond to your inquiries and requests</li>
                <li>Send you updates and marketing communications (with your consent)</li>
                <li>Analyze usage patterns and improve our website</li>
                <li>Comply with legal obligations</li>
              </ul>
            </div>

            <div className="legal-section">
              <h2>Data Retention</h2>
              <p>
                We retain your personal information only for as long as necessary to fulfill the purposes outlined in this Privacy Policy, unless a longer retention period is required by law.
              </p>
            </div>

            <div className="legal-section">
              <h2>Third-Party Processors</h2>
              <p>
                We may share your information with third-party service providers who assist us in operating our website and conducting our business, including:
              </p>
              <ul>
                <li>Cloud hosting providers</li>
                <li>Email marketing platforms</li>
                <li>Analytics services (Google Analytics)</li>
                <li>CRM systems</li>
              </ul>
            </div>

            <div className="legal-section">
              <h2>Cookies</h2>
              <p>
                We use cookies and similar tracking technologies to track activity on our website and hold certain information. You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent.
              </p>
            </div>

            <div className="legal-section">
              <h2>Your Rights</h2>
              <p>You have the right to:</p>
              <ul>
                <li>Access the personal information we hold about you</li>
                <li>Request correction of inaccurate information</li>
                <li>Request deletion of your personal information</li>
                <li>Opt-out of marketing communications</li>
                <li>Object to processing of your personal information</li>
              </ul>
            </div>

            <div className="legal-section">
              <h2>Contact Us</h2>
              <p>
                If you have any questions about this Privacy Policy, please contact us at:
                <br />
                <strong>Email:</strong> contact@BigSoftTech.in
                <br />
                <strong>Phone:</strong> 05324050303                <br />
                <strong>Offices:</strong> Prayagraj (Civil Lines) & Noida (Sector 62), Uttar Pradesh, India
              </p>
            </div>
          </div>
        </div>
      </section>

\    </div>
  );
};

export default Privacy;